import {
  RainbowKitProvider,
  connectorsForWallets,
  midnightTheme,
} from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { defaultWagmiConfig } from "@web3modal/wagmi";
import { WagmiProvider } from "wagmi";
import { arbitrum, mainnet } from "wagmi/chains";
import {
  metaMaskWallet,
  walletConnectWallet,
  coinbaseWallet,
  ledgerWallet,
  rainbowWallet,
  rabbyWallet,
  magicEdenWallet,
  frameWallet,
  trustWallet,
} from "@rainbow-me/rainbowkit/wallets";

const queryClient = new QueryClient();

const projectId = process.env.REACT_APP_WALLETCONNECT_KEY;

const metadata = {
  name: "yuga",
  description: "Yuga-Dashbo",
  url: "bayc.dashbo.xyz",
  icons: [""],
};

const chains = [mainnet];

const connectors = connectorsForWallets(
  [
    {
      groupName: "Recommended",
      wallets: [metaMaskWallet, walletConnectWallet, coinbaseWallet],
    },
    {
      groupName: "More",
      wallets: [
        rabbyWallet,
        rainbowWallet,
        magicEdenWallet,
        ledgerWallet,
        frameWallet,
        trustWallet,
      ],
    },
  ],
  {
    projectId,
    appName: metadata.name,
  }
);

// Configure wagmi
export const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  connectors,
  auth: {
    email: false,
    socials: [],
    showWallets: true,
    walletFeatures: false,
  },
});

export function Web3ModalProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={midnightTheme()}>
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
